import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule } from './shared/components/side-nav-outer-toolbar/side-nav-outer-toolbar.component';
import { UnauthenticatedContentModule } from './shared/components/unauthenticated-content/unauthenticated-content';
import { AppInfoService } from './shared/services/app-info.service';
import { AuthService } from './shared/services/auth.service';
import { AddHeaderInterceptor } from './shared/services/httpInterceptor';
import { ScreenService } from './shared/services/screen.service';


import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxMaskModule } from 'ngx-mask';
import { AceiteDeTermosModule } from './pages/aceite-de-termos/aceite-de-termos.module';
import { AcessoPessoalModule } from './pages/acesso-pessoal/acesso-pessoal.module';
import { AcessosModule } from './pages/acessos/acessos.module';
import { AdmLicencasModule } from './pages/adm-licencas/adm-licencas.module';
import { ApresentacaoSistemaModule } from './pages/apresentacao-sistema/apresentacao-sistema.module';
import { AutocadastroFormModule } from './pages/autocadastro-form/autocadastro-form.module';
import { ClientesModule } from './pages/clientes/clientes.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { DevolutivaModule } from './pages/devolutiva/devolutiva.module';
import { AdminEmailsModule } from './pages/admin-emails/admin-emails.module';
import { EquipesModule } from './pages/equipes/equipes.module';
import { PessoalLicencasModule } from './pages/pessoal-licencas/pessoal-licencas.module';
import { PlayModule } from './pages/play/play.module';
import { RecomendacoesModule } from './pages/recomendacoes/recomendacoes.module';
import { RelatoriosModule } from './pages/relatorios/relatorios.module';
import { SkinsModule } from './pages/skins/skins.module';
import { TermoDeUsoModule } from './pages/termo-de-uso/termo-de-uso.module';
import { TestesModule } from './pages/testes/testes.module';
import { DialogModule } from './shared/components/dialog/dialog.module';
import { HeaderModule } from "./shared/components/header/header.module";
import { NotificationService } from './shared/services/notificationService';


@NgModule({
    declarations: [
        AppComponent,
    ],
    providers: [
        AuthService,
        ScreenService,
        AppInfoService,
        NotificationService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AddHeaderInterceptor,
            multi: true
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: { duration: 2500 }
        },
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        UnauthenticatedContentModule,
        SideNavOuterToolbarModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        NgxMaskModule.forRoot({
            dropSpecialCharacters: true
        }),
        MatSnackBarModule,
        HeaderModule,
        DialogModule,

        // Rotas do sistema
        DashboardModule,
        AcessosModule,
        AppRoutingModule,
        ClientesModule,
        SkinsModule,
        AcessoPessoalModule,
        EquipesModule,
        TestesModule,
        AdmLicencasModule,
        PessoalLicencasModule,
        PlayModule,
        TermoDeUsoModule,
        AceiteDeTermosModule,
        AutocadastroFormModule,
        RelatoriosModule,
        ApresentacaoSistemaModule,
        RecomendacoesModule,
        DevolutivaModule,
        AdminEmailsModule
    ],
})
export class AppModule { }
